import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { RolesService, IRole, IWidget } from '../roles.service';
import { RolesFormComponent } from '../roles-form/roles-form.component';
import { combineLatest } from 'rxjs';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss']
})
export class RolesListComponent implements OnInit, OnDestroy {

  constructor(private service: RolesService, public dialog: MatDialog) { }

  @ViewChild('container', { static: false }) container: ElementRef;
  list: IRoleEx[] = [];
  loading = false;
  displayedColumns = ['id', 'name', 'description', 'widgets', 'option'];
  containerHeight = 0;
  combined = null;

  widgets: IWidget[] = [];

  ngOnInit() {
    this.loading = true;
    this.getList();
  }

  ngOnDestroy() {
    this.combined.unsubscribe();
  }

  getList() {
    this.combined = combineLatest(
      this.service.getList(),
      this.service.getWidgets()
    ).subscribe(res => {
      this.loading = false;
      this.widgets = res[1];
      this.list = this.updateList(res[0], res[1]);
      setTimeout(() => {
        this.getHeight();
      }, 100);
    });
  }

  getHeight() {
    const bodyHeight = document.body.clientHeight;
    const containerOffsetTop = this.container.nativeElement.offsetTop;
    this.containerHeight = bodyHeight - containerOffsetTop - 50;
  }

  updateList(list: IRole[], widgets: IWidget[]) {
    const res: IRoleEx[] = list.map(l => {
      return {
        id: l.id,
        name: l.name,
        description: l.description,
        widgets: l.widgets,
        widgetsEx: []
      };
    });
    res.forEach(f => {
      f.widgetsEx = f.widgets.map(w => {
        const fWidget = widgets.find(wi => wi.id === w);
        return {
          id: typeof(fWidget) === 'undefined' ? w : fWidget.id,
          title: typeof (fWidget) === 'undefined' ? '' : fWidget.title,
          letter: typeof (fWidget) === 'undefined' ? '-' : fWidget.letter
        };
      });
      // .sort((a, b) => (a.letter > b.letter) ? 1 : ((b.letter > a.letter) ? -1 : 0))
    });
    return res;
  }

  editRole(i) {
    const dialogRef = this.dialog.open(RolesFormComponent, {
      width: '80%',
      height: '80%',
      data: { type: 'edit', data: this.list[i], widgets: this.widgets },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result === 'cool') {
          this.getList();
        }
      }
    });
  }

  createRole() {
    const data = { name: '', description: '', widgets: [] };
    const dialogRef = this.dialog.open(RolesFormComponent, {
      width: '80%',
      height: '80%',
      data: { type: 'create', data: data, widgets: this.widgets },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result === 'cool') {
          this.getList();
        }
      }
    });
  }
  getWidgets() {
    this.service.getWidgets().subscribe(res => {
      this.widgets = res;
    });
  }

}


export interface IRoleEx extends IRole {
  widgetsEx: IWidget[];
}
